if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      this.cartDrawer = document.querySelector('cart-drawer');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      const submitButton = this.querySelector('[type="submit"]');
      submitButton.setAttribute('disabled', true);
      submitButton.classList.add('button--loading');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const sectionsToFetch = [
        ...this.cartDrawer.getSectionsToRender().map((section) => section.id),
        ...this.cartNotification.getSectionsToRender().map((section) => section.id),
      ];

      const formData = new FormData(this.form);
      let revenue = this.form.querySelector('input[name="quantity"]').value * this.form.querySelector('input[name="price"]').value / 100;

      formData.append('sections', sectionsToFetch);
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((parsedState) => {
          if (parsedState.status == 422) {
            // When quantity error
            this.cartNotification.setActiveElement(document.activeElement);
            this.cartNotification.renderQuantityError(formData.get('inventory_quantity'));
            return;
          }

          window.parsedState = parsedState;

          this.cartDrawer.renderContents(parsedState);

          switch (submitButton.dataset.addToCartBehavior) {
            case 'open_cart_drawer':
              // Set timeout to force animation. Because content is just updated with renderContents
              setTimeout(() => {
                this.cartDrawer.open();
              });
              break;
            case 'show_cart_notification':
            default:
              this.cartNotification.setActiveElement(document.activeElement);
              this.cartNotification.renderContents(parsedState);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('button--loading');
          submitButton.removeAttribute('disabled');
          if (typeof _tfa !== 'undefined') {
            let saved_taboola_id = sessionStorage.getItem('taboola_id');
            if (saved_taboola_id === null) {
              saved_taboola_id = 1463766;
            }
            _tfa.push({notify: 'event', name: 'add_to_cart', id: saved_taboola_id, revenue: revenue});
          }
          if (typeof amzn !== 'undefined') {
            let data = window.parsedState;
            let amazonObj = {};
            amazonObj.value = data.final_line_price / 100;
            amazonObj.currencyCode = Shopify.currency.active;
            amazonObj.unitsSold = data.quantity;
            amazonObj.contentId = data.key;
            amazonObj.name = data.title;
            amzn("trackEvent", "AddToCart", amazonObj);
          }
          let pnktdata = window.parsedState;
          pintrk('track', 'addtocart', {value: revenue, order_quantity: pnktdata.quantity, currency: Shopify.currency.active, product_id: pnktdata.id});
        });
    }
  }

  window.ProductForm = ProductForm;
  customElements.define('product-form', ProductForm);
}
